import API_ENDPOINTS from '../constants/api_endpoints';

import { realBricksApi } from './api.service';

export const getRevenueReportsService = (
  page,
  limit,
  sortField,
  sortType,
  duration
) => {
  return realBricksApi.get(
    `${API_ENDPOINTS.REPORTS.GetRevenueReports}?page=${page}&limit=${limit}&sortField=${sortField}&sortType=${sortType}`,
    {
      params: {
        duration,
      },
    }
  );
};

export const getRecurringRevenueService = (
  page,
  limit,
  sortField,
  sortType,
  duration
) => {
  return realBricksApi.get(
    `${API_ENDPOINTS.REPORTS.GetRecurringRevenueReports}?page=${page}&limit=${limit}&sortField=${sortField}&sortType=${sortType}`,
    {
      params: {
        duration,
      },
    }
  );
};

export const getUserAcquiredService = (
  page,
  limit,
  sortField,
  sortType,
  duration
) => {
  return realBricksApi.get(
    `${API_ENDPOINTS.REPORTS.UsersAcquiredReports}?page=${page}&limit=${limit}&sortField=${sortField}&sortType=${sortType}`,
    {
      params: {
        duration,
      },
    }
  );
};

export const getUsersByAgeService = (
  page,
  limit,
  sortField,
  sortType,
  duration
) => {
  return realBricksApi.get(
    `${API_ENDPOINTS.REPORTS.UsersByAgeReports}?page=${page}&limit=${limit}&sortField=${sortField}&sortType=${sortType}`,
    {
      params: {
        duration,
      },
    }
  );
};

export const getUsersByStateService = (
  page,
  limit,
  sortField,
  sortType,
  duration
) => {
  return realBricksApi.get(
    `${API_ENDPOINTS.REPORTS.UsersByStateReports}?page=${page}&limit=${limit}&sortField=${sortField}&sortType=${sortType}`,
    {
      params: {
        duration,
      },
    }
  );
};

export const getMostLikedPropertiesService = (
  page,
  limit,
  sortField,
  sortType,
  duration
) => {
  return realBricksApi.get(
    `${API_ENDPOINTS.REPORTS.MostLikedProperties}?page=${page}&limit=${limit}&sortField=${sortField}&sortType=${sortType}`,
    {
      params: {
        duration,
      },
    }
  );
};

export const getMostTradedPropertiesService = (
  page,
  limit,
  sortField,
  sortType,
  duration
) => {
  return realBricksApi.get(
    `${API_ENDPOINTS.REPORTS.MostTradedProperties}?page=${page}&limit=${limit}&sortField=${sortField}&sortType=${sortType}`,
    {
      params: {
        duration,
      },
    }
  );
};

export const getMostAppreciatedService = (
  page,
  limit,
  sortField,
  sortType,
  duration
) => {
  return realBricksApi.get(
    `${API_ENDPOINTS.REPORTS.MostAppreciatedProperties}?page=${page}&limit=${limit}&sortField=${sortField}&sortType=${sortType}`,
    {
      params: {
        duration,
      },
    }
  );
};

export const getRevenueChartsService = () => {
  return realBricksApi.get(`${API_ENDPOINTS.REPORTS.GetRevenueCharts}`);
};

export const getRecurringRevenueChartsService = () => {
  return realBricksApi.get(
    `${API_ENDPOINTS.REPORTS.GetRecurringRevenueCharts}`
  );
};

export const getUsersAcquiredChartsService = () => {
  return realBricksApi.get(`${API_ENDPOINTS.REPORTS.GetAcquiredUsersCharts}`);
};

export const getUsersStatesChartsService = () => {
  return realBricksApi.get(`${API_ENDPOINTS.REPORTS.GetUsersStateCharts}`);
};

export const downloadReportsService = (
  reportName,
  sortField,
  sortType,
  search,
  duration
  // propertyId,
  // filterBy,
  // filterValues
) => {
  const isSearchIncluded = search?.length > 0;
  let queryString = '';
  if (isSearchIncluded) {
    queryString = `&search=${search}`;
  }

  // queryString = userId ? `${queryString}&userId=${userId}` : queryString;
  // queryString = duration ? `${queryString}&duration=${duration}` : queryString;
  // queryString = propertyId
  //   ? `${queryString}&propertyId=${propertyId}`
  //   : queryString;
  // queryString = filterBy
  //   ? `${queryString}&filterBy=${filterBy}&filterValues=${JSON.stringify(
  //       filterValues
  //     )}`
  //   : queryString;

  // sortField=${sortField}&sortType=${sortType}
  return realBricksApi.get(
    `${API_ENDPOINTS.REPORTS.DownloadReports}/${reportName}?${queryString}&sortType=${sortType}&page=1&limit=10`,
    {
      params: {
        duration,
      },
    }
  );
};
